import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IStoreData } from '../@types/Store';

@Injectable()
export class StoreWidgetService {
  constructor(private http: HttpClient) {}

  private get baseUrl(): string {
    return `${environment.apiBaseUrl}/api`;
  }

  private getStoreId(): number {
    const selected = localStorage.getItem('ss_SelectedStoreId');
    if (selected) {
      return Number(selected);
    }

    const storeJson = localStorage.getItem('store');
    if (storeJson) {
      try {
        const parsed = JSON.parse(storeJson);
        if (parsed?.SelectedStoreId) {
          return Number(parsed.SelectedStoreId);
        }
      } catch {
        // ignore parse error
      }
    }

    return 163;
  }

  private buildHeaders(extra: Record<string, string> = {}): HttpHeaders {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...extra
    };

    const token = localStorage.getItem('access_token');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    return new HttpHeaders(headers);
  }

  async detailStoreInfosByID(store_id: number | undefined): Promise<Observable<IStoreData>> {
    console.log('list_store widget')
    const url = `${this.baseUrl}/public/admin/store/${store_id}/list_store`;
    return this.http.get<IStoreData>(url, { headers: this.buildHeaders() }).pipe(
      catchError(err => throwError(() => err))
    );
  }

  async listarAssetsWidget2(widget_id: number | undefined, page: number = 1, limit: number | null = 10): Promise<Observable<IStoreData>> {
    const headers = this.buildHeaders({ 'X-Full-Referer': window.location.href });
    const storeId = this.getStoreId();
    const resolvedLimit = limit ?? 9;
    const url = `${this.baseUrl}/admin/store/${storeId}/videoshopping/widget/${widget_id}/assets?page=${page}&limit=${resolvedLimit}`;

    return this.http.get<IStoreData>(url, { headers }).pipe(
      catchError(err => throwError(() => err))
    );
  }

  listarAssetsWidgetPublic(widget_id: number | undefined, page: number = 1, limit: number | null = 10, store_id: number | undefined): Observable<IStoreData> {
    const headers = this.buildHeaders({
      'X-Full-Referer': window.location.href
    });

    let storeId = store_id ?? 163;
    const storeJson = localStorage.getItem('store');
    if (storeJson) {
      try {
        const parsed = JSON.parse(storeJson);
        if (parsed?.SelectedStoreId) {
          storeId = parsed.SelectedStoreId;
        }
      } catch {
        // ignore parse error
      }
    }

    const resolvedLimit = limit ?? 9;
    const url = `${this.baseUrl}/public/admin/store/${storeId}/videoshopping/widget/${widget_id}/assets_public?page=${page}&limit=${resolvedLimit}`;

    return this.http.get<IStoreData>(url, { headers }).pipe(
      catchError(err => throwError(() => err))
    );
  }
}
